import { TabDrawerLayout } from '@Components/shared/layouts/TabDrawerLayout';
import { DrawerHeaderLayout } from '@Components/shared/layouts/DrawerHeaderLayout';
import { SetupMinesRoundHeader } from './SetupMinesRoundDrawerHeader';
import { Divider } from '@mui/material';
import { Stack } from '@mui/material';
import { useMinesRoundDrawer } from '@Modal/hooks/rounds/useMinesRoundDrawer';
import { useDispatch } from 'react-redux';
import { SetupMinesRoundDrawerDetails } from './SetupMinesRoundDrawerDetails';

export const SetupMinesRoundDrawerContent: React.FC = () => {
  const dispatch = useDispatch();
  const { setShowRoundDrawer } = useMinesRoundDrawer();

  return (
    <TabDrawerLayout
      header={
        <DrawerHeaderLayout
          currentSlug="/rounds"
          onClose={() => dispatch(setShowRoundDrawer(false))}
        >
          <SetupMinesRoundHeader />
        </DrawerHeaderLayout>
      }
      footer={<></>}
    >
      <Stack>
        <Divider />
        <SetupMinesRoundDrawerDetails />
      </Stack>
    </TabDrawerLayout>
  );
};
